<template>
	<div class="uk-margin-remove" v-if="showAlert" :id="'alert-' + id" uk-alert>
		<a class="uk-alert-close" uk-close @click="closeAlert"></a>
		<h4 v-show="title">{{ title }}</h4>
		<p>{{ message }}</p>
	</div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
	name: 'Alert',
	props: {
		id: {
			type: String,
			required: true,
		},
		once: Boolean,
		title: String,
		message: String,
	},	
	data() {
		return {
			showAlert: false
		}
	},
	mounted() {
		if(!this.once || 
				this.once && 
				!Cookies.get('alertClosed-' + this.id)) {
			this.showAlert = true;
		}
	},
	methods: {
		closeAlert() {
			if(this.once) {
				Cookies.set('alertClosed-' + this.id, 'true', { expires: 365 })
			}
			this.showAlert = false
		}
	}
}
</script>

<style scoped>
</style>
